import React, { useState, useEffect } from "react";
import './grafica.css';
import axios from "axios";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";
import { bitcoinHistoricalMonthly } from "../../../assets/data/bitcoinHistoricalMonthly.js";
import { useTranslation } from "react-i18next";

import back_i from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';

const timeRanges = [
    { label: "Histórico", local: true },
    { label: "Mensual", days: 30 },
    { label: "Anual", days: 361 },
];

const parsePrice = (priceStr) => {
    if (typeof priceStr === "number") return priceStr;
    return parseFloat(priceStr.replace(/\./g, "").replace(",", "."));
};

const Grafica = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [price, setPrice] = useState(null);
    const [chartData, setChartData] = useState([]);
    const [range, setRange] = useState(timeRanges[0]);
    const [loading, setLoading] = useState(false);

    const fetchPrice = async () => {
        try {
            const res = await axios.get(
                "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd"
            );
            setPrice(res.data.bitcoin.usd);
        } catch (error) {
            console.error("Error fetching current price:", error);
            setPrice(null);
        }
    };

    const fetchHistory = async (days) => {
        setLoading(true);
        try {
            const res = await axios.get(
                `https://api.coingecko.com/api/v3/coins/bitcoin/market_chart`,
                {
                    params: {
                        vs_currency: "usd",
                        days,
                        interval: "daily",
                    },
                }
            );
            const data = res.data.prices.map(([timestamp, price]) => ({
                time: new Date(timestamp).toLocaleDateString("es-ES", {
                    month: "short",
                    day: "numeric",
                }),
                price,
            }));
            setChartData(data);
        } catch (error) {
            console.error("Error fetching historical data:", error);
            setChartData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPrice();

        if (range.local) {
            const historicalData = bitcoinHistoricalMonthly.map((item) => ({
                time: item.date,
                price: parsePrice(item.price),
            })).reverse();
            setChartData(historicalData);
        } else {
            fetchHistory(range.days);
        }
    }, [range]);

    return (
        <div className="landing_bitcoin_grafica max-w-3xl mx-auto p-4 bg-white rounded-2xl shadow-md">
            <div className="landing_bitcoin_grafica_content">
                <h2 className="text-2xl font-semibold mb-4 text-center text-gray-800" dangerouslySetInnerHTML={{ __html: (t('grafica.titulo')) }}>
                    
                </h2>

                <div className="h-64 chart-container">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" tick={{ fontSize: 10 }} />
                            <YAxis domain={["auto", "auto"]} />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="price"
                                stroke="#facc15"
                                strokeWidth={2}
                                dot={false}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                    <div className="landing_bitcoin_grafica_flotante">
                        <p className="text-3xl font-bold text-center text-yellow-500 mb-6">
                        {t('grafica.precio')}<br />
                            {price !== null
                                ? new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }).format(price)
                                : "Cargando..."}
                        </p>
                    </div>
                </div>
                <h3 className="chart-opciones text-xl font-medium mb-2 text-gray-700 text-center">
                    Precio de Bitcoin - {range.label}
                </h3>
                <div className="chart-opciones flex justify-center gap-2 mb-4">
                    {timeRanges.map((t) => (
                        <button
                            key={t.label}
                            onClick={() => setRange(t)}
                            className={`px-4 py-1 rounded-full border ${range.label === t.label
                                ? "bg-yellow-400 text-white border-yellow-500"
                                : "bg-white border-gray-300 text-gray-700"
                                } hover:shadow-sm transition`}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>
            <img class="landing_bitcoin_registro_img_i" src={back_i}></img>
            <img class="landing_bitcoin_registro_img_d" src={back_d}></img>
            {loading && <p className="text-center mt-2 text-gray-500">Cargando datos...</p>}
        </div>
    );
};

export default Grafica;